import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "slider" }
const _hoisted_2 = ["min", "max", "step"]



export default /*@__PURE__*/_defineComponent({
  __name: 'ValueSlider',
  props: /*@__PURE__*/_mergeModels({
  min: Number,
  max: Number,
  step: Number
}, {
    "modelValue": {
  },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props) {



const model = _useModel<number>(__props, "modelValue", {
  set (value) {
    if (typeof value === 'string') value = parseInt(value)
    return value
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", null, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _withDirectives(_createElementVNode("input", {
      type: "range",
      min: __props.min,
      max: __props.max,
      step: __props.step,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event))
    }, null, 8, _hoisted_2), [
      [_vModelText, model.value]
    ])
  ]))
}
}

})